import { z } from 'zod/v4';
import { ITariffServiceArea } from '../../tariff/product-group.interfaces';
import { ETariffCredentialType } from './tariff-credential.enums';
import { Brand } from '../../branded-types';

export type TariffCredentialId = Brand<string, 'tariffCredentialId'>;

export interface ITariffServiceAreaWithCredentialType extends ITariffServiceArea {
  credential?: ITariffCredential;
}

export interface ITariffCredential {
  id?: TariffCredentialId;
  tariffAreaId: number;
  credentialType?: ETariffCredentialType;
}

export const TARIFF_CREDENTIAL_SCHEMA: z.ZodType<ITariffCredential> = z.object({
  id: z
    .string()
    .transform((s: string) => s as TariffCredentialId)
    .optional(),
  tariffAreaId: z.number(),
  credentialType: z.enum(ETariffCredentialType).optional(),
});

export const TARIFF_CREDENTIALS_SCHEMA: z.ZodType<ITariffCredential[]> =
  z.array(TARIFF_CREDENTIAL_SCHEMA);

export const TARIFF_CREDENTIAL_WITH_TYPE_SCHEMA: z.ZodType<ITariffServiceAreaWithCredentialType> =
  z.object({
    id: z.number(),
    name: z.string(),
    nameLang: z.string().nullable().default(null),
    version: z.string().nullable().default(null),
    credential: TARIFF_CREDENTIAL_SCHEMA.optional(),
    credentialType: z.enum(ETariffCredentialType).optional(),
  });

export const TARIFF_CREDENTIALS_WITH_TYPE_SCHEMA: z.ZodType<
  ITariffServiceAreaWithCredentialType[]
> = z.array(TARIFF_CREDENTIAL_WITH_TYPE_SCHEMA);
